/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { ExperienceEntity } from './experience-entity';
export class ExperiencesFocusAreaOrderPreferenceEntity extends Entity {
  createdAt: string | null = null;
  experience: ExperienceEntity | null = null;
  experienceId: string | null = null;
  focusAreas: string[] | null = null;
  id: string = '';
  updatedAt: string | null = null;
  static override key = 'ExperiencesFocusAreaOrderPreference';
  static override get schema() {
    return {
      experience: ExperienceEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'ExperiencesFocusAreaOrderPreference' in input
    ) {
      const { ExperiencesFocusAreaOrderPreference: wrapped, ...rest } = input as {
        ExperiencesFocusAreaOrderPreference: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}